module.exports = ".veriff-submit {\n  background: #111212 !important;\n  width: 100%;\n  height: 44px;\n  line-height: 44px;\n  text-align: center;\n  margin: 24px 0 48px 0;\n  border-radius: 6px;\n  color: #fff;\n  padding: 0px;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 16px;\n  padding: 0 24px;\n  width: initial;\n  -webkit-transition: all 0.15s ease-in-out;\n  transition: all 0.15s ease-in-out;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/veriff/veriff.component.scss
// module id = ./src/app/veriff/veriff.component.scss
// module chunks = main